import axios from "axios";
import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface CompleteMembershipAgreementRequest {
  token: string;
  isSpv?: boolean;
}

const completeMembershipAgreement = async ({
  token,
  isSpv = false,
}: CompleteMembershipAgreementRequest) => {
  try {
    const query = `?isSpv=${isSpv}`;

    const response = await axios.post(
      `${BASE_URL}/trade-directory/users/agreed-to-membership-agreement${query}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default completeMembershipAgreement;
